'use client';

import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip
} from 'recharts';

/**
 * Maturity labels
 */
const MATURITY_LABELS = {
  0: 'Not Started',
  1: 'Learner',
  2: 'Explorer',
  3: 'Transformative',
  4: 'Professional'
};

/**
 * Background ring colors (low → high maturity)
 */
const MATURITY_COLORS = {
  0: '#fca5a5', // red
  1: '#fdba74', // orange
  2: '#fde047', // yellow
  3: '#86efac', // green
  4: '#60a5fa'  // blue
};

export default function MaturityRadarChart({ dimensionData }) {
  if (!dimensionData || dimensionData.length === 0) {
    return <p>No data available</p>;
  }

  // Normalize data
  const radarData = dimensionData.map(item => ({
    name: item.name,
    maturity: Number(item.maturity)
  }));

  return (
    <div style={{ width: '100%', height: 560 }}>
      <ResponsiveContainer>
        <RadarChart data={radarData}>
          
          {/* Grid */}
          <PolarGrid />

          {/* Dimension labels */}
          <PolarAngleAxis
            dataKey="name"
            tick={{ fontSize: 11 }}
            tickLine={false}
          />

          {/* Maturity scale */}
          <PolarRadiusAxis
            domain={[0, 4]}
            ticks={[0, 1, 2, 3, 4]}
            tickFormatter={(value) => MATURITY_LABELS[value]}
            tick={{ fontSize: 11 }}
          />

          {/* ===== Colored maturity background rings ===== */}
          {[0, 1, 2, 3, 4].map(level => (
            <Radar
              key={`ring-${level}`}
              dataKey={() => level}
              stroke="none"
              fill={MATURITY_COLORS[level]}
              fillOpacity={0.08}
              isAnimationActive={false}
              dot={false}
              activeDot={false}
            />
          ))}

          {/* ===== Actual maturity data ===== */}
          <Radar
            name="Maturity Level"
            dataKey="maturity"
            stroke="#1d4ed8"
            fill="#3b82f6"
            fillOpacity={0.35}
            dot={false}
            activeDot={false}
          />

          {/* Tooltip */}
          <Tooltip
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                const data = payload[0].payload;
                return (
                  <div style={{
                    backgroundColor: '#1f2937',
                    color: 'white',
                    padding: '10px 14px',
                    border: 'none',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    fontSize: '13px'
                  }}>
                    <p style={{ margin: '0 0 4px 0' }}>
                      <strong>Dimension:</strong> {data.name}
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>Maturity:</strong> {MATURITY_LABELS[data.maturity]}
                    </p>
                  </div>
                );
              }
              return null;
            }}
          />

        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}